@if (projections().length === 0) {
  <ng-container
    [ngTemplateOutlet]="leaflet"
    [ngTemplateOutletContext]="{ projection: ProjectionCode.Mercator }"
  >
  </ng-container>
} @else if (projections().length === 1) {
  @let projection = projections()[0];
  @switch (projection) {
    @case (ProjectionCode.Arctic) {
      <ng-container
        [ngTemplateOutlet]="leaflet"
        [ngTemplateOutletContext]="{ projection: ProjectionCode.Arctic }"
      >
      </ng-container>
    }
    @case (ProjectionCode.Antarctic) {
      <ng-container
        [ngTemplateOutlet]="leaflet"
        [ngTemplateOutletContext]="{ projection: ProjectionCode.Antarctic }"
      >
      </ng-container>
    }
    @default {
      <ng-container
        [ngTemplateOutlet]="leaflet"
        [ngTemplateOutletContext]="{ projection: ProjectionCode.Mercator }"
      >
      </ng-container>
    }
  }
} @else {
  <mat-tab-group [headerPosition]="headerPosition()">
    @for (projection of projections(); track projection) {
      <mat-tab>
        <ng-template mat-tab-label>
          @if (featuresCount()[projection]; as count) {
            <b style="white-space: pre">({{ count }}) </b>
          }
          {{ projectionLabels.get(projection) }}
        </ng-template>
        <ng-template matTabContent>
          <ng-container
            [ngTemplateOutlet]="leaflet"
            [ngTemplateOutletContext]="{ projection: projection }"
          >
          </ng-container>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
}

<ng-template #leaflet let-projection="projection">
  <app-leaflet
    #leafletComponentRef
    [height]="height()"
    [projectionName]="projection"
    [geometry]="geometry()"
    [readonly]="readonly()"
    (geometryChange)="geometryChange.emit($event)"
  ></app-leaflet>
</ng-template>
